import React from 'react';
import PropTypes from 'prop-types';
import { FilterSelect } from '@td/ui';
import { translate } from '@td/shared_utils';
import { NEW_PATIENT_STATUSES } from '../constants/filterOptions';

const NEW_PATIENT_FILTER_OPTIONS = Object.keys(NEW_PATIENT_STATUSES).map((value) => ({
  value,
  label: translate(null, 'provider_panel.filters.fields.new_patients_status.options', value.toLowerCase()),
}));

const NEW_PATIENT_FILTER_LABEL = translate(null, 'provider_panel.filters.fields.new_patients_status', 'label');

const NewPatientFilter = React.memo(({ value, onChange }) => (
  <FilterSelect
    isSearchable={false}
    isMulti
    label={NEW_PATIENT_FILTER_LABEL}
    value={value}
    onChange={onChange}
    options={NEW_PATIENT_FILTER_OPTIONS}
  />
));

NewPatientFilter.propTypes = {
  value:    PropTypes.object.isRequired,
  label:    PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

NewPatientFilter.displayName = 'NewPatientFilter';

export default NewPatientFilter;
